import * as React from "react";
import { useEffect, useState } from "react";
import { ConfirmDialog } from "../Dialogs";
import SimpleButton from "./SimpleButton";

interface IProps {
    isAdmin: boolean;
    post: any;
    onDelete: (newsId, isDeleted, isPermanent) => void;
    className?: string;
    type?: "a" | "button";
    text?: string;
    showIcon?: boolean;
}

const DeleteButton = (props: IProps) => {
    const [popupMessage, setPopupMessage] = useState("");
    const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);

    useEffect(() => {
        setIsDeleted(props.post?.deleted === true);
    }, [props.post]);

    return props.isAdmin ? (
        isDeleted ? (
            <>
                <SimpleButton
                    className={props.className || "NR_itemLink CMS_button CMS_bSquare CMS_bCancel"}
                    title="Delete"
                    type={props.type}
                    href={"#"}
                    onClick={async (e) => {
                        e.preventDefault();
                        setPopupMessage("Are you sure that you want to permanently delete this post?");
                        setIsConfirmDeleteOpen(true);
                    }}
                >
                    {props.showIcon ? <em className="fa fa-trash"></em> : null} {props.text || ""}
                </SimpleButton>
                <ConfirmDialog
                    isOpen={isConfirmDeleteOpen}
                    message={popupMessage}
                    callBack={async (value) => {
                        setIsConfirmDeleteOpen(false);
                        if (value) {
                            await props.onDelete(props.post.newsId, true, true);
                        }
                    }}
                />
            </>
        ) : null
    ) : null;
};

export default DeleteButton;
